import { CardContent, CardHeader, Grid2, IconButton, Stack, Tooltip } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialBox from "../../../components/MaterialBox"
import Table from "../../../components/Table"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useCategoryListHandling } from "./components/CategoryStateHandle"
import CategorySelect from "../../../components/CategorySelect"
import CategoryCreateConfirmationDialog from "./components/CategoryCreateConfirmationDialog"
import MaterialButton from "../../../components/MaterialButton"
import { Add, Edit, FileUpload, FilterAlt } from "@mui/icons-material"
import CategoryForm from "./components/CategoryForm"
import { deleteData, fetchData, postData } from "../../../services"
import { useDispatch, useSelector } from "react-redux"
import { setCategoryData,setRowsPerPage,setCurrentPage, setTotalPages } from "./reducers/categorySlice"
import { useSnackbar } from "../../../context/popup"
import UploadFile from "../../Utils/UploadFile"
import { useLoading } from "../../../components/Loading"
import BulkUpload from "../../../components/blukUplod"
import { roundIconButtonSX } from "./components/CategoryStyle"
import GeneralKVStoreFilterDialog from "./components/GeneralKVStoreFilterDialog.js";

const CategoryList = () => {

    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.generalKeyValueStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalKeyValueStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalKeyValueStore?.totalPages);

    const [showTable, setShowTable] = useState(false);
    const [showCategoryForm, setShowCategoryForm] = useState(false);    
    const [showConfirmationBox, setShowConfirmationBox] = useState(false);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [listResponseData, setListResponseData] = useState([]);
    const [keyValueListData, setKeyValueListData] = useState([]);
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [openStoreUploadFileDialog, setOpenStoreUploadFileDialog] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: ""
    });
    const dispatch = useDispatch();
    const { categoryId, category } = useSelector(
        (state) => state.category
    );
        
    const { listData, setListData } = useCategoryListHandling({setShowTable});
    
    useEffect(() => {
        
        if(!categoryId){
            return
        }
        fetchKeyValueList(categoryId);
        setShowTable(true);            
        
    },[categoryId, currentPage, rowsPerPage, search]);
    
    useEffect(() => {
        fetchCategoryList();
    },[])

    //Dropdown API
    const fetchCategoryList = async () => {
        try {
        const response = await fetchData(`/reference/general/key-value-category`)        
        const responseData = response?.data?.items;
        setListResponseData(responseData);
        
        if(response?.success){
            const options = responseData.map((item) => ({
                value: item.id,
                label: item.categoryName,
            }));            
            setCategoryOptions(options);
        }
        else{
            //throw error
            showSnackbar("Error Fetching Category Data","error");
        }
        } catch (error) {
            console.error('Error Fetching Categories:', error);
            showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
    };

    //Key Value Table
    const fetchKeyValueList = async (categoryId) => {
        setCircleLoading(true);
        try {
            let url = `/reference/general/key-value-store?categoryId=${categoryId}&page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                                
            //for active and inactive status
            if(filterData.isActive !== "") {
                url += `&isActive=${filterData.isActive}`;
            }
    
            const response = await fetchData(url);
            const responseData = response?.data?.items;
            if(response?.success){
                setKeyValueListData(responseData);
                dispatch(setTotalPages(response?.data?.totalPages));
            }
        } catch (error) {
            console.error('Error Fetching Key Values:', error);
            showSnackbar(`Error Fetching ${category} Data`,"error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/master/bulkUpload/general-key-value-store`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
                setUploadSuccess(true)
                showSnackbar(result?.message,"success");
                setOpenUploadFileDialog(false);
                setClearFileOnSuccess(true);
                fetchKeyValueList(categoryId); 
            }
            else {
                setUploadSuccess(false);
                showSnackbar('Faiiled to upload file', "error")
            }

        } catch (error) {
                const errorMessage = error?.response?.data?.message;                
                console.error('Upload error:', error || errorMessage)
                showSnackbar(errorMessage, "error")
        } 
        finally {
                setFileUploading(false)
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/general/key-value-store-delete`,{ids:[row?.id]});
            if(response?.success){
                showSnackbar(response?.message, "success");
                fetchKeyValueList(categoryId);
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            showSnackbar("Error Deleting Category", "error");
            console.error("Error deleting data:", error);
        }
    };

    //Table Mapping
    const keyValueListTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },
            { key: "keyName", label: "Key Name", renderCell: (row) => row.keyName },
            { key: "category", label: "Category", renderCell: (row) => row.category },
            { key: "createdAt", label: "Created At", renderCell: (row) => row.createdAt },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],

        rows: keyValueListData?.map((kv, index) => ({
            id: kv?.id,
            sno: index + 1,
            keyName: kv?.keyName || "",
            category: kv?.category?.categoryName + " - " + kv?.category?.code || "",
            isActive: kv?.isActive,
            createdAt: kv?.createdAt
            ? new Date(kv.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                })
            : "",
        })),
    };

    //table actions
    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/category-list/key-value-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/category-list/key-value-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    //handle change for master category dropdown
    const handleCategoryChange = (newCategory) => {
        //fetch dropdown(dont remove this)
        fetchCategoryList();

        //reset the table(mandatory)
        dispatch(setCurrentPage(1));
        dispatch(setRowsPerPage(10));
        dispatch(setTotalPages(1));

        //Fallback
        if (!newCategory) {
            setShowTable(false);
            // setDescription("");
            setShowConfirmationBox(false);
            return;
        }
        const exists = categoryOptions.some(
            (option) => option.label.toLowerCase() === newCategory.toLowerCase()
        );

        const selected = listResponseData?.find(
            (item) => item.categoryName.toLowerCase() === newCategory.toLowerCase()
        );
        
        const selectedDescription = selected?.description || "";
        const selectedCode = selected?.code || "";
        const selectedActive = selected?.isActive;
        setShowTable(exists || selected);
        setShowConfirmationBox(!exists && !selected);
        
        //to set globally using redux toolkit
        setListData((prev) => ({ 
            ...prev, 
            categoryId: selected?.id,
            category: newCategory, 
            code: selectedCode, 
            description: selectedDescription, 
            active: selectedActive 
        }));

        dispatch(setCategoryData({ 
            categoryId: selected?.id, 
            category: newCategory, 
            code: selectedCode, 
            description: selectedDescription, 
            active: selectedActive  
        }));
        
        if (exists) {
            setShowTable(true);
            setShowConfirmationBox(false);
        } else {
            setShowConfirmationBox(true);
            setShowTable(false);
        }
        
    };
    
    const handleAddKeyValue = () => {
        navigate('/general-master/category-list/key-value-details', {
            state: { category: listData?.category, categoryId: listData?.categoryId }
        });
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
      };
    
    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        {/* Create Form */}
        {showConfirmationBox && (
            <CategoryCreateConfirmationDialog
            showConfirmationBox={showConfirmationBox}
            setShowConfirmationBox={setShowConfirmationBox}
            categoryName={listData?.category}
            />
        )}

        {/* Edit Form */}
        {showCategoryForm && (
            <CategoryForm
            showCategoryForm={showCategoryForm}
            setShowCategoryForm={setShowCategoryForm}
            listData={listData}
            setListData={setListData}
            />
        )}
        <CardHeader
        title={(
            <Stack direction="row" spacing={2} alignItems="center">

                <Stack direction="column" spacing={0} flex={1}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                    Category List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                    List of available category names. Click on a category to view its respective list. 
                    To create a new category, enter the name in the dropdown.
                    </MaterialTypography>
                </Stack>

                <Stack
                    direction="row"
                    spacing={1}
                    flex={1}
                    justifyContent="flex-end"
                >
                    
                    {showTable && (
                        <>
                            <Tooltip title={`Bulk Upload ${category}`} disableInteractive>
                                <IconButton color="dark" size="small"  
                                onClick={() => setOpenUploadFileDialog(true)}
                                sx={roundIconButtonSX}>
                                    <FileUpload />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={`Filter ${category}`} disableInteractive>
                                <IconButton color="dark" size="small"  
                                onClick={(event) => setAnchorEl(event.currentTarget)}
                                sx={roundIconButtonSX}>
                                    <FilterAlt />
                                </IconButton>
                            </Tooltip>

                            <MaterialButton
                                variant="gradient"
                                color="dark"
                                size="small"
                                startIcon={<Add />}
                                onClick={handleAddKeyValue}
                            >
                                {category !== "" ? category : "Key Value"}
                            </MaterialButton>
                        </>
                    )}
                </Stack>
            </Stack>

        )} 
        />
        <CardContent>

            <Grid2 container spacing={3} alignItems="center">
                <Grid2 size={{lg:4, md:4, sm: 10, xs: 10 }}>
                    <MaterialBox>
                        <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        >
                            Category
                        </MaterialTypography>
                    </MaterialBox>                
                   <CategorySelect
                    id={categoryId}
                    value={category}
                    onChange={handleCategoryChange}
                    options={categoryOptions}
                    fetchCategoryList={fetchKeyValueList}
                    />
 
                </Grid2>
                {showTable && (
                <Grid2 size={{lg:4, md:4, sm: 2, xs: 2 }}>
                    <MaterialBox mt={4}>
                        <Tooltip title="Edit Category Details" disableInteractive>
                            <IconButton onClick={() => setShowCategoryForm(true)}>
                                <Edit/>
                            </IconButton>
                        </Tooltip>
                    </MaterialBox>
                </Grid2>
                )}
            </Grid2>
            <MaterialBox mt={2}>            
                {showTable && (
                <Table
                columns={keyValueListTable?.columns}
                data={keyValueListTable?.rows}
                actions={actions}
                pagination={{
                    totalPages,
                    currentPage,
                    onPageChange: (page) => handlePaginationChange(page),
                    rowsPerPage,
                    onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                    rowsPerPageOptions: [5, 10, 15, 20],
                }}
                getRowKey={(row) => row.id}
                className="custom-table"
                noDataLabel="No Key Values found"
                handleSearch={handleSearch}
                />
                )}
            </MaterialBox>
        </CardContent>
        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <BulkUpload
            categoryId={categoryId}
            open={openStoreUploadFileDialog}
            setOpen={setOpenStoreUploadFileDialog}
            endPoint="/reference/master/bulkUpload/general-key-value-store"
            fetchList={fetchKeyValueList}
        />
        <GeneralKVStoreFilterDialog
        category={category}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchKeyValueList(categoryId);  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default CategoryList